<template>
  <div id="inline-video" class="mx-auto max-w-4xl w-full">
    <div class="px-12 text-center">
      <SectionHeader class="mb-2">How Does Bambee Work?</SectionHeader>
      <p class="font-body-medium font-medium xs:font-body-large text-gray-2">
        Bambee gives you a dedicated HR Manager who helps you craft HR policy
        and maintain&nbsp;compliance.
      </p>
    </div>
    <button class="block mx-auto" title="Watch the video" @click="showContent">
      <picture>
        <source
          srcset="
            ~/assets/images/splash/video-preview.jpg,
            ~/assets/images/splash/video-preview-2x.jpg 2x
          "
          media="(min-width: 640px)"
        />
        <source
          srcset="
            ~/assets/images/splash/video-preview-xs.jpg,
            ~/assets/images/splash/video-preview-xs-2x.jpg 2x
          "
          media="(min-width: 480px)"
        />
        <source
          srcset="~/assets/images/splash/video-preview-2xs-2x.jpg 2x"
          media="(max-width: 479px)"
        />
        <img
          src="~/assets/images/splash/video-preview-2xs.jpg"
          load="lazy"
          alt=""
          class="block max-w-full"
          :style="{ 'min-width': '279px' }"
        />
      </picture>
    </button>
    <Portal :disabled="!isModalActive">
      <transition name="fade" appear @afterLeave="isModalActive = false">
        <VideoModal v-if="isContentActive" @close="isContentActive = false" />
      </transition>
    </Portal>
  </div>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal';
import SectionHeader from '@/components/SectionHeader';

const VideoModal = () => import('@/components/VideoModal');

export default {
  components: { Portal, SectionHeader, VideoModal },
  data() {
    return {
      isContentActive: false,
      isModalActive: false,
    };
  },
  methods: {
    showContent() {
      this.isModalActive = true;
      this.isContentActive = true;
    },
  },
};
</script>
